enum CheckStateEnum {
	/** 0 - node is leaf and is not checked, node is not leaf and none. */
	unchecked = 0,
	/** 1 - node is leaf and is checked, node is not leaf and all of its children are checked (checked). */
	indeterminate = 2,
	/** 2 - node is not leaf and some of its children are checked (indeterminate state). */
	checked = 1,
}
export default CheckStateEnum;
